import { Box, Snowflake, Tag, Scale, Layers } from 'lucide-react';

export const ProductSpecs = ({ product }) => {
  const specs = [
    { Icon: Scale, l: 'Unit weight', v: product.weight },
    { Icon: Box, l: 'Case pack', v: product.unitCase },
    { Icon: Snowflake, l: 'Shelf life', v: product.shelfLife },
    { Icon: Tag, l: 'Format', v: product.format },
  ];
  return (
    <section className="py-16 bg-parchment/40">
      <div className="container mx-auto">
        <div className="grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="font-script text-2xl text-leaf">in this line</div>
            <h2 className="font-display text-3xl sm:text-4xl text-primary font-medium mt-1 leading-tight">SKUs & variants</h2>
            <p className="text-muted-foreground mt-3 max-w-md">
              Order the full line or mix-and-match by SKU. Allergen sheets, macros, and case dimensions are delivered with every quote.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary text-xs font-medium text-primary">
              <Layers className="h-3.5 w-3.5 text-leaf" /> {product.variants.length} SKU{product.variants.length > 1 ? 's' : ''} in this catalog
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-3">
              {product.variants.map((v, i) => (
                <div key={v} className="flex items-start gap-3 p-4 rounded-2xl bg-card border border-border/70">
                  <div className="h-8 w-8 shrink-0 rounded-full gradient-leaf text-primary-foreground grid place-items-center font-display text-xs font-semibold">
                    {String(i + 1).padStart(2, '0')}
                  </div>
                  <div className="text-sm text-primary/90 leading-relaxed pt-1">{v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
          {specs.map(({ Icon, l, v }) => (
            <div key={l} className="flex items-start gap-4 p-5 rounded-2xl bg-card border border-border/70">
              <div className="h-11 w-11 shrink-0 rounded-xl bg-secondary text-leaf grid place-items-center">
                <Icon className="h-5 w-5" />
              </div>
              <div>
                <div className="text-[11px] uppercase tracking-[0.16em] text-muted-foreground">{l}</div>
                <div className="font-display text-base text-primary font-medium mt-0.5 leading-snug">{v}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductSpecs;
